import { cn } from '@/lib/utils';
import { KeyBadge } from './key-badge';

export type RailItem = { id: string; title: string; key: string };

/** Coluna de músicas do repertório (modos Nítido e Partitura). */
export const SetlistRail: React.FC<{
  title: string;
  items: RailItem[];
  current: number;
  onSelect: (index: number) => void;
  className?: string;
}> = ({ title, items, current, onSelect, className }) => (
  <nav
    aria-label="Músicas do repertório"
    className={cn('flex flex-col gap-2 print:hidden', className)}
  >
    <p className="col-label truncate text-faint">{title}</p>
    <ol className="flex flex-col gap-1">
      {items.map((item, index) => (
        <li key={item.id}>
          <button
            type="button"
            onClick={() => onSelect(index)}
            aria-current={index === current ? 'true' : undefined}
            className={cn(
              'flex w-full items-center gap-2.5 rounded-[10px] border px-2.5 py-2 text-left transition-colors',
              index === current
                ? 'border-accent-line bg-accent-surface'
                : 'border-transparent hover:bg-raised',
            )}
          >
            <span
              className={cn(
                'w-4 shrink-0 text-center font-bold text-[12px]',
                index === current ? 'text-accent-ink' : 'text-faint',
              )}
            >
              {index + 1}
            </span>
            <span
              className={cn(
                'min-w-0 flex-1 truncate text-[13px]',
                index === current ? 'font-semibold text-white' : 'text-muted-foreground',
              )}
            >
              {item.title}
            </span>
            <KeyBadge value={item.key} className="h-5 min-w-7 px-2 text-[11px]" />
          </button>
        </li>
      ))}
    </ol>
  </nav>
);
